<template>
    <svg width="22" height="22" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill="#B6BCCA" d="M17.506 3.364l1.414 1.414L4.778 18.92l-1.414-1.414z"/><path fill="#B6BCCA" d="M3.364 4.778l1.414-1.414L18.92 17.506l-1.414 1.414z"/></svg>
</template>

<script>
  export default {
    name: "CloseIcon"
  }
</script>